import React, { useEffect } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Avatar,
} from '@mui/material';
import { partnersLogo } from '../../../assets/partners';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCampaigns, updateCampaignDeduplication } from '../../../redux/thunks/campaignThunks';
import { actions } from '../../../redux/reducers/customerSettingsReducer';
import { differenceInDays } from "date-fns";

function DeduplicatePhysiciansTable(props) {
    const { } = props;
    const dispatch = useDispatch()
    const { company } = useSelector((state) => state.company);
    const { campaigns } = useSelector((state) => state.customerSettings);
    const currentDate = new Date();
    const startDate = new Date(2021, 0, 1);
    const daysDifference = differenceInDays(currentDate, startDate);
    const DEDUPLICATION_MAX_VALUE = daysDifference;
    // Validation with REGEX
    const MAX_VALUE_PATTERN = /^([0-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9])?$/;

    const partnersIconMapping = (name) => {
        const brand = name?.toLowerCase();
        for (const partnerName in partnersLogo) {
            if (brand.includes(partnerName)) {
                return partnersLogo[partnerName];
            }
        }
        return null;
    };

    const getLimitedValue = (value) => {
        return Math.max(0, Math.min(value, DEDUPLICATION_MAX_VALUE))
    }

    const handleDeduplicationChange = (row, e) =>{
        let value = e.target.value
        let newValue = null
        if (MAX_VALUE_PATTERN.test(value)) {
            if (value !== '') {
                newValue = getLimitedValue(Number.parseInt(value))
                dispatch(updateCampaignDeduplication({companyId:company.id, campaignId:row.id, deduplication:newValue}))
            }
            dispatch(actions.handleDeduplicationChange({value:value===""? value:newValue,id:row.id}))
        }
    }
    const renderNoTableData = () => {
        return (
            <TableRow>
                <TableCell colSpan={5}>
                    <Box textAlign="center" p={3}>
                        <Typography className="text-sm-regular gray-900">
                            No Campaigns data to display.
                        </Typography>
                    </Box>
                </TableCell>
            </TableRow>
        );
    };

    useEffect(() => {
        if(company.id){
            dispatch(getAllCampaigns({ companyId: company.id }))
        }
    },[company.id])

    return (
        <Box className="box-sizing-border-box border-1-gray br-8px">
            {/* Table Content */}
            <Box>
                <TableContainer component={Paper} className='no-box-shadow no-border'>
                    <Table className='table-border-collapse no-border'>
                        <TableHead>
                            <TableRow>
                                <TableCell className="table-headers-title" align='center'>ID</TableCell>
                                <TableCell className="table-headers-title" align='center'>Name</TableCell>
                                <TableCell className="table-headers-title" align='center'>Queries</TableCell>
                                <TableCell className="table-headers-title text-align-center" align='center'>Deduplication (Days)</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { campaigns.length>0 ? campaigns.map((row, index) => (
                                <>
                                    <TableRow key={row.id} className={index % 2 === 0 ? 'odd-row-background ' : ''}>
                                        <TableCell className='table-row-data no-border' align='center' >
                                            {row.id}
                                        </TableCell>
                                        <TableCell className='table-row-data no-border' >
                                            <Box className="flex-column-center gap-12" >
                                                 <Avatar
                                                    src={partnersIconMapping(row.name)}
                                                    className="border-1-gray br-16px wh-40px"
                                                    alt={row.name}
                                                >
                                                    {row.name?.charAt(0)}
                                                </Avatar>
                                                <Typography className="text-sm-medium gray-900">
                                                    {row.name}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell className='table-row-data no-border' >
                                            <Box className="flex-row-wrap center-align gap-4">
                                                {
                                                    row.triggers?.map((query) => {
                                                        return <Box className="flex-column-center br-16px bg-gray-100 padding-tb-4-rl-12">
                                                            <Typography className='text-xs-medium gray-700'>
                                                                {query.name}
                                                            </Typography>
                                                        </Box>
                                                    })
                                                }
                                            </Box>
                                        </TableCell>
                                        <TableCell className='table-row-data no-border flex-column-center' >
                                            <Box className="max-width-90px flex-column-center">
                                                <input
                                                    className='custom-text-field'
                                                    type='number'
                                                    min="0"
                                                    max={DEDUPLICATION_MAX_VALUE}
                                                    maxLength={4}
                                                    pattern="[+-]?\d+(?:[.,]\d+)?"
                                                    value={row.deduplication} onChange={(e) => handleDeduplicationChange(row, e)}
                                                />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </>
                            )) :renderNoTableData()}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    )
};


export default DeduplicatePhysiciansTable;